import Axios from "axios";
import { LOGIN, LOGOUT, SOFT_LOGOUT, CHECK } from "./mutation-types";
import { AuthState } from "./state";
import { SHARE_EMAIL_CONSENT, TERMS_CONDITION_CONSENT } from "@/constants";

export default {
    [CHECK](state: AuthState) {
        if (localStorage.getItem("stqr_token") && localStorage.getItem("stqr_uid")) {
            const currentSession = localStorage.getItem("stqr_token");
            const currentUser = localStorage.getItem("stqr_uid");

            state.authenticated = true;
            state.sessionToken = currentSession;
            state.userId = currentUser;

            Axios.defaults.headers.common.Authorization = `session ${currentSession}`;
        }
    },

    [LOGIN](
        state: AuthState,
        sessionData: {
            session: string;
            userId: string;
            remindsMe: boolean;
            isGoogleAccount?: boolean;
            accountCreated?: boolean;
        }
    ) {
        // store token & uid in local storage or cookie only if user consents
        if (sessionData.remindsMe) {
            localStorage.setItem("stqr_token", sessionData.session);
            localStorage.setItem("stqr_uid", sessionData.userId);
        }

        state.didSignUp = sessionData.accountCreated || false;
        state.authenticated = true;
        state.userId = sessionData.userId;
        state.sessionToken = sessionData.session;
        state.isGoogleAccount = sessionData.isGoogleAccount || false;

        Axios.defaults.headers.common.Authorization = `session ${sessionData.session}`;
    },

    [LOGOUT](state: AuthState) {
        localStorage.removeItem("stqr_token");
        localStorage.removeItem("stqr_uid");
        localStorage.removeItem(TERMS_CONDITION_CONSENT);
        localStorage.removeItem(SHARE_EMAIL_CONSENT);

        state.authenticated = false;
        state.userId = "";
        state.sessionToken = "";

        delete Axios.defaults.headers.common.Authorization;
    },

    // Logout but do not clear storage. Used by qrcodes with "NO_ACCOUNT"
    [SOFT_LOGOUT](state: AuthState) {
        state.authenticated = false;
        state.userId = "";
        state.sessionToken = "";

        delete Axios.defaults.headers.common.Authorization;
    }
};
